/**
 * Realtime de chat con Laravel Echo + Pusher protocol (Reverb)
 * Sprint 11 - HU-FE-04
 */

import type { ChatMessageEventPayload } from '../types/chat';
import { getDeviceUuid } from './deviceIdentity';
import { disconnectRealtime, subscribeToPrivateEvent } from './realtime';

type MessageEventHandler = (payload: ChatMessageEventPayload) => void;

function subscribeToChatMessages(
    channelName: string,
    authToken: string,
    handler: MessageEventHandler,
    onConnectionStateChange?: (connected: boolean) => void,
): () => void {
    return subscribeToPrivateEvent<unknown>({
        authToken,
        channelName,
        eventName: '.MessageSent',
        handler: (payload) => {
            const event = payload as ChatMessageEventPayload;

            if (!event || typeof event.conversation_id !== 'number' || !event.message) {
                return;
            }

            handler(event);
        },
        onError: (message) => {
            console.warn('[ChatRealtime]', message);
        },
        onConnectionStateChange,
    });
}

export function subscribeToConversationMessages(
    conversationId: number,
    authToken: string,
    handler: MessageEventHandler
): () => void {
    return subscribeToChatMessages(
        `chat.conversation.${conversationId}.${getDeviceUuid()}`,
        authToken,
        handler,
    );
}

export function subscribeToUserChatMessages(
    userId: number,
    authToken: string,
    handler: MessageEventHandler,
    onConnectionStateChange?: (connected: boolean) => void,
): () => void {
    return subscribeToChatMessages(
        `chat.user.${userId}.${getDeviceUuid()}`,
        authToken,
        handler,
        onConnectionStateChange,
    );
}

export function disconnectChatRealtime(): void {
    disconnectRealtime();
}
